import { ServerModelWithDateStrings } from "@teamprevent/common/utils";
import axios from "axios";

import { OhCaseDetailModel, parseOhCaseModel } from "../crud/ohCase/model";

const create = async (customerId: string, employeeRecordId: string, genericCaseTypeId: string) => {
    const response = await axios.post<ServerModelWithDateStrings<OhCaseDetailModel>>(
        `/api/customer/${customerId}/employeeRecord/${employeeRecordId}/genericCase`, { genericCaseTypeId });

    return parseOhCaseModel(response.data);
};

export const genericCaseApi = { create };
